<template>
  <div class="basicinfo-container">
    <div class="basicinfo-container_ cen">
      <div class="inside-main">
        <div class="basicinfo-main">
          <div class="volunteer-detail-item">基本信息</div>
          <div class="basicinfo-form">
            <div class="basicinfo-inputbox">
              <div class="basicinfo-item">姓名：</div>
              <div class="basicinfo-input">{{formdata.name}}</div>
            </div>
            <div class="basicinfo-inputbox">
              <div class="basicinfo-item">居住地址：</div>
              <div class="basicinfo-input">{{formdata.address}}</div>
            </div>
            <div class="basicinfo-inputbox">
              <div class="basicinfo-item">性别：</div>
              <div class="basicinfo-input">{{sex[formdata.sex]}}</div>
            </div>
            <div class="basicinfo-inputbox">
              <div class="basicinfo-item">出生日期：</div>
              <div class="basicinfo-input" id="date">{{formdata.birthday}}</div>
            </div>
            <div class="basicinfo-inputbox">
              <div class="basicinfo-item">民族：</div>
              <div class="basicinfo-input">{{formdata.nationality}}</div>
            </div>
            <div class="basicinfo-inputbox">
              <div class="basicinfo-item">文化程度：</div>
              <div class="basicinfo-input">{{formdata.education}}</div>
            </div>
            <div class="basicinfo-inputbox">
              <div class="basicinfo-item">居住情况：</div>
              <div class="basicinfo-input">{{living[formdata.living]}}</div>
            </div>
          </div>
        </div>
        <div class="inside-left-nav">
          <div class="left-nav-head" @click="backMember">
            <div class="chname">返回</div>
            <div class="enname">Back</div>
          </div>
          <div class="left-nav-list">
            <div class="left-nav-li active">
              <router-link :to="{ path: '/attention/index', query: { id: id } }" class="left-nav-link">
                <div class="chname">基本信息</div>
                <div class="enname">Basic Information</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li">
              <router-link :to="{ path: '/attention/reserve', query: { id: id } }" class="left-nav-link">
                <div class="chname">预约信息</div>
                <div class="enname">Reservation information</div>
                <span></span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getHeaderData, getBindMemberData } from '../../api/getData.js'
export default {
  name: 'attentionBasicInfo',
  data () {
    return {
      headerInfo: {},
      id: '',
      sex: ['男', '女'],
      living: ['独居', '非独居'],
      formdata: {
        name: '',
        address: '',
        sex: '1',
        birthday: '',
        nationality: '',
        education: '',
        living: ''
      }
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getUserId'
    ])
  },
  created () {
    this.id = this.$route.query.id === undefined ? '' : this.$route.query.id
    this.getHeaderInfo()
    this.getMemberInfo()
  },
  methods: {
    async getHeaderInfo () {
      let header = await getHeaderData()
      this.headerInfo = header.header
      this.$store.dispatch('SetActiveMenu', { activeMenu: 'member', activeSendMenu: 'member' }).then(() => {}).catch(() => {})
    },
    async getMemberInfo () {
      let postData = { user_id: this.getUserId, member_id: this.id }
      let result = await getBindMemberData(postData)
      if (result.code === '0') {
        this.message('您未绑定该用户')
        return false
      }
      this.formdata.name = result.info.cnname
      this.formdata.address = result.info.address
      this.formdata.sex = result.info.sex
      this.formdata.birthday = result.info.birthday
      this.formdata.nationality = result.info.nation
      this.formdata.education = result.info.education
      this.formdata.living = result.info.livestatus
    },
    backMember () {
      this.$router.push({ path: '/member/family' })
    },
    message (content) {
      this.$alert(content, '提示', {
        confirmButtonText: '确定',
        callback: action => {}
      })
    }
  }
}
</script>

<style scoped lang="less">
  .inside-main{
    padding: 40px 0 60px;
  }
  .basicinfo-main{
    width: 77.22%;
    padding: 0 0 78px;
    background-color: #ffffff;
    box-shadow: 0px 0px 13px 0px rgba(37, 37, 37, 0.15);
    border-radius: 5px;
    .volunteer-detail-item{
      border-left: 4px solid #eb6420;
      margin-top: 60px;
      margin-left: 62px;
      padding-left: 25px;
      font-size: 30px;
      line-height: 30px;
      color: #eb6420;
    }
    .basicinfo-form{
      margin-top: 42px;
      padding-bottom: 62px;
      .basicinfo-inputbox{
        margin-bottom: 43px;
        overflow: hidden;
        .basicinfo-item{
          float: left;
          width: 187px;
          margin-right: 3px;
          font-size: 24px;
          line-height: 40px;
          text-align: right;
          color: #333333;
        }
        .basicinfo-input{
          overflow: hidden;
          font-size: 24px;
          line-height: 40px;
          text-align: left;
          color: #333333;
        }
      }
      .basicinfo-btn{
        width: 200px;
        height: 50px;
        margin: 110px auto 0;
        border-radius: 4px;
        background-color: #eb6420;
        font-size: 18px;
        line-height: 50px;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
  .inside-left-nav{
    .left-nav-head{
      cursor: pointer;
    }
  }
  @media screen and (max-width: 1300px){
    .basicinfo-main{
      .basicinfo-form{
        .basicinfo-inputbox{
          .basicinfo-input{
            select{
              margin-right: 15px;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1200px){
    .inside-main{
      padding: 25px 0 5px;
    }
    .basicinfo-main{
      width: 100%;
      margin-bottom: 20px;
      padding: 30px 0 65px;
      border-radius: 3px;
      .volunteer-detail-item{
        border-left: 2px solid #eb6420;
        margin-top: 0;
        margin-left: 30px;
        padding-left: 12px;
        font-size: 15px;
        line-height: 15px;
      }
      .basicinfo-form{
        margin-top: 21px;
        padding-bottom: 0;
        padding-left: 30px;
        padding-right: 30px;
        .basicinfo-inputbox{
          margin-bottom: 13px;
          .basicinfo-item{
            width: 80px;
            margin-right: 0;
            font-size: 14px;
            line-height: 32px;
            text-align: left;
          }
          .basicinfo-input{
            font-size: 14px;
            line-height: 32px;
            text-align: left;
          }
        }
        .basicinfo-btn{
          width: 100px;
          height: 25px;
          margin: 45px auto 0;
          border-radius: 2px;
          font-size: 14px;
          line-height: 25px;
        }
      }
    }
    .inside-left-nav{
      display: none;
    }
  }
</style>
